(()=>{
 const headline='Join VIP Now And Get 20% Off';
 const watched=new WeakSet();
 const isClubHeading=t=>/^join\s+(?:(?:lailey[’\x27]?s?|the\s+lailey(?:\s+girls)?|the)\s+)?(?:vip\s+)?club[!\s♡💌]*$/iu.test(t.trim());
 function update(root){
  for(const el of root.querySelectorAll('h1,h2,h3,[role="heading"],button,[role="button"],p,span,strong,div')){
   const text=el.textContent.trim();
   if(el.children.length===0&&(isClubHeading(text)||/^join (?:vip )?now and get 20% off$/i.test(text))&&text!==headline){el.textContent=headline;}
   if(/^join\s+the\s+other\s+[\d,\s]+\s*vip\s+members[!.\s]*$/i.test(text)){el.textContent='Join the other VIP members';}
  }
  for(const el of root.querySelectorAll('*'))if(el.shadowRoot)watch(el.shadowRoot);
 }
 function watch(root){
  if(watched.has(root))return;watched.add(root);
  let scheduled=false;
  new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;update(root)})}}).observe(root,{subtree:true,childList:true,characterData:true});
  update(root);
 }
 watch(document);
 
 const poll=setInterval(()=>update(document),750);setTimeout(()=>clearInterval(poll),30000);
})();